// Allows only artefact, web, mail and in-app links; any other scheme (javascript:, data:, …) is dropped.
export const urlTransform = (url: string): string => {
  if (url.startsWith("artefact://")) {
    return url;
  }
  if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("mailto:")) {
    return url;
  }
  if (url.startsWith("/") || url.startsWith("#") || url.startsWith("./") || url.startsWith("../")) {
    return url;
  }
  return "";
};
